<template>
	<BuyersOrderGroup
		name="Taxes Total"
		class="ignore-all-locks"
	>
		<template #group-action>
			<span class="new-tax-line">
				<button
					class="button button-edit"
					@click="onAddEditTaxLineClick()"
					:disabled="isAddTaxLineDisabled"
				>
					<i class="fas fa-plus" />
					New Tax Line
				</button>
			</span>
		</template>

		<template #right-icon>
			<span>+</span>
		</template>

		<template #column-1>
			<InputCurrency
				:saturn="bo.finalNumbers.taxTotal"
				:disabled="true"
				:precision="2"
				iconSide="left"
				:negative="true"
			/>
		</template>

		<template #children>
			<BuyersOrderRow
				v-for="taxLine in bo.taxGroups"
				:key="taxLine.name"
			>
				<template #left-icon>
					<span
						v-if="bo.isLease()"
						class="buyers-order-upfront-capped-icon"
					>
						<Pill
							label="U"
							status="success"
							:size="10"
							:includeDot="false"
						/>
					</span>
				</template>

				<template #info>
					<button
						class="button-link"
						@click="onAddEditTaxLineClick(taxLine)"
					>
						{{ taxLine.name }} ({{ taxLine.rate.toFixed(3) }}%)
					</button>
				</template>

				<template #right-icon>
					<span>+</span>
				</template>

				<template #column-1>
					<InputCurrency
						:saturn="taxLine.taxTotal"
						:disabled="true"
						:precision="2"
						iconSide="left"
						:negative="true"
					/>
				</template>
			</BuyersOrderRow>

			<template v-if="bo.isLease()">
				<template v-if="bo.isLeaseMonthlyUse">
					<BuyersOrderRow
						v-for="taxLine in bo.taxGroups"
						:key="taxLine.name"
					>
						<template #left-icon>
							<span class="buyers-order-upfront-capped-icon">
								<Pill
									label="U"
									status="success"
									:size="10"
									:includeDot="false"
								/>
							</span>
						</template>

						<template #info> <span>CCR</span> {{ taxLine.name }} </template>

						<template #right-icon>
							<span>+</span>
						</template>

						<template #column-1>
							<InputCurrency
								:saturn="taxLine.leaseInfo.ccrTaxAmount"
								:disabled="true"
								:precision="2"
								iconSide="left"
								:negative="true"
							/>
						</template>
					</BuyersOrderRow>
				</template>

				<BuyersOrderRow v-else>
					<template #left-icon>
						<span class="buyers-order-upfront-capped-icon">
							<Pill
								label="U"
								status="success"
								:size="10"
								:includeDot="false"
							/>
						</span>
					</template>

					<template #info>
						<span>Cap Cost Reduction Tax</span>
					</template>

					<template #right-icon>
						<span>+</span>
					</template>

					<template #column-1>
						<InputCurrency
							:saturn="bo.finalNumbers.leaseFinalNumbers.capCostReductionTaxAmount"
							:disabled="true"
							:precision="2"
							iconSide="left"
							:negative="true"
						/>
					</template>
				</BuyersOrderRow>

				<template v-if="bo.isLeaseMonthlyUseNY">
					<BuyersOrderRow
						v-for="monthlyUseItem in bo.finalNumbers.leaseFinalNumbers.monthlyUseTaxInfo"
						:key="monthlyUseItem.taxLineName"
					>
						<template #left-icon>
							<span class="buyers-order-upfront-capped-icon">
								<Pill
									label="U"
									status="success"
									:size="10"
									:includeDot="false"
								/>
							</span>
						</template>

						<template #info>
							<span>Monthly Use {{ monthlyUseItem.taxLineName }} ({{ monthlyUseItem.taxLineRate.toFixed(2) }}%)</span>
						</template>

						<template #right-icon>
							<span>+</span>
						</template>

						<template #column-1>
							<InputCurrency
								:saturn="monthlyUseItem.taxLineTotalTaxAmount"
								:disabled="true"
								:precision="2"
								iconSide="left"
								:negative="true"
							/>
						</template>
					</BuyersOrderRow>
				</template>
			</template>
		</template>
	</BuyersOrderGroup>
</template>

<script setup lang="ts">
	import BuyersOrderGroup from './BuyersOrderGroup.vue';
	import BuyersOrderRow from './BuyersOrderRow.vue';
	import FIMenuBuyersOrder from '@core/classes/FIMenuBuyersOrder';
	import FIMenuBuyersOrderTaxGroup from '@core/classes/FIMenuBuyersOrderTaxGroup';
	import InputCurrency from '@core/components/InputCurrency.vue';
	import Pill from '@core/components/Pill.vue';

	interface IBuyersOrderTaxesTotalProps {
		bo: FIMenuBuyersOrder;
		isAddTaxLineDisabled: boolean;
	}

	const { bo, isAddTaxLineDisabled } = defineProps<IBuyersOrderTaxesTotalProps>();

	const emit = defineEmits<{
		addEditTaxLineClick: [taxLine: FIMenuBuyersOrderTaxGroup];
	}>();

	function onAddEditTaxLineClick(taxLine: FIMenuBuyersOrderTaxGroup = null) {
		emit('addEditTaxLineClick', taxLine);
	}
</script>

<style scoped></style>
